import { useEffect, useState } from "react";

import { type DealerLogoData, shuffle } from "@/src/utils/dealerLogoUtils";

// The first render uses the given (prerendered, alphabetical) order so
// hydration matches; shuffling on the next frame gives every dealer an equal
// chance at the top. `source` ties the shuffle to the data it was made from.
export const useShuffledAfterHydration = (
  dealerLogos: DealerLogoData
): DealerLogoData => {
  const [shuffled, setShuffled] = useState<{
    source: DealerLogoData;
    logos: DealerLogoData;
  }>();

  useEffect(() => {
    const frame = requestAnimationFrame(() =>
      setShuffled({
        source: dealerLogos,
        logos: {
          primary: shuffle(dealerLogos.primary),
          secondary: shuffle(dealerLogos.secondary)
        }
      })
    );
    return () => cancelAnimationFrame(frame);
  }, [dealerLogos]);

  return shuffled?.source === dealerLogos ? shuffled.logos : dealerLogos;
};
